module.exports = __webpack_public_path__ + "static/media/spinner.33efbf8c.svg";